import React from "react";
import * as XLSX from "xlsx";

/**
 * Creates & downloads an empty Excel template with required columns
 * (NO API call)
 *
 * Column order matches backend UploadExcel:
 * 1 ProductName
 * 2 CompanyName
 * 3 ShortName
 * 4 CatalogueName
 * 5 QualityName
 * 6 DesignNumber
 * 7 WRate
 * 8 XRate
 * 9 Date   (yyyy-mm-dd)
 */
export default function DownloadProductExcelTemplate({
  fileName = "Product_Import_Template.xlsx",
  className = "pp-menuBtn",
  onClickDone, // optional
}) {
  const handleDownload = () => {
    const headers = [
      "ProductName",
      "DesignNumber",
      "WRate",
      "XRate",
      "Date", // yyyy-mm-dd
    ];

    // ✅ Empty sheet with only header row
    const ws = XLSX.utils.aoa_to_sheet([headers]);

    // ✅ Column widths (optional but helps user)
    ws["!cols"] = [
      { wch: 18 }, // ProductName
      { wch: 14 }, // DesignNumber
      { wch: 10 }, // WRate
      { wch: 10 }, // XRate
      { wch: 12 }, // Date
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products");

    // ✅ Optional: add a Help sheet (doesn't affect upload)
    const help = XLSX.utils.aoa_to_sheet([
      ["Instructions"],
      ["- Fill data in Products sheet only."],
      ["- Date format: All formats supported (e.g. 20-03-2026, 20/03/2026, 2026-03-20, or leave empty for today)"],
      ["- WRate and XRate should be numbers."],
      ["- Do not change header names/order."],
    ]);
    help["!cols"] = [{ wch: 60 }];
    XLSX.utils.book_append_sheet(wb, help, "Help");

    // ✅ Download
    XLSX.writeFile(wb, fileName);

    onClickDone?.();
  };

  return (
    <button type="button" className={className} onClick={handleDownload}>
      <span className="pp-menuEmoji">⬇️</span>
      Download Excel Template
    </button>
  );
}
